import { Box, Grid,CircularProgress} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CiCircleQuestion } from "react-icons/ci";

import { PrimeGrayBorderColorButton, RedColorBorderButton,RedColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CustomModal from "../../Components/Modal/CustomModal";
import { LogoutUser } from "../../Components/Helpers/Api";
import { PostMethod } from "../../Helper/api"
const SideBarData = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [SideBarData, setSideBarData] = useState([]);
  const [SuccessModal, setSuccessModal] = useState(false);
  const [ConformModal, setConformModal] = useState(false);
  const [DeleteLoader, setDeleteLoader] = useState(false);
  const [Checked, setChecked] = useState(false);

  const Locationfilter = (path) => {
    if (
      path == "/settings/applicationsettings/mcqcategories" ||
      path == "/settings/applicationsettings/educationqualifications" ||
      path == "/settings/applicationsettings/educationlevels" ||
      path == "/settings/applicationsettings/religions" ||
      path == "/settings/applicationsettings/nextofkinrelationship" ||
      path == "/settings/applicationsettings/physicalscreening" ||
      path == "/settings/applicationsettings/medicalscreening" ||
      path == "/settings/applicationsettings/chairmansignature" ||
      path == "/settings/applicationsettings/baseaddress" ||
      path == "/settings/applicationsettings/cbtlocations" ||
      path == "/settings/applicationsettings/physicalandmedicallocations" ||
      path == "/settings/applicationsettings/reasonsforrejections"
    ) {
      return "/settings/applicationsettings/mcqcategories";
    }
    if (path == "/settings/profile") {
      return "/settings/profile";
    }
    if (path == "/settings/changepasword") {
      return "/settings/changepasword";
    }
    if (path == "/settings/recruitmentinstructions") {
      return "/settings/recruitmentinstructions";
    }
    if (path == "/settings/termsofservices") {
      return "/settings/termsofservices";
    }
    if (path == "/settings/privacyandpolicy") {
      return "/settings/privacyandpolicy";
    }
    if (path == "/settings/loungecontract") {
      return "/settings/loungecontract";
    }
    if (path == "/settings/faqs") {
      return "/settings/faqs";
    }
    if (path == "/settings/deleteaccount") {
      return "/settings/deleteaccount";
    }
  };

  const AdminSideBarData = [
    {
      name: "My Profile",
      isActive: false,
      navigate: "/settings/profile",
    },
    {
      name: "Change Pasword",
      isActive: false,
      navigate: "/settings/changepasword",
    },
    {
      name: "Applications Settings",
      isActive: false,
      navigate: "/settings/applicationsettings/mcqcategories",
    },
    {
      name: "Recruitment Instructions",
      isActive: false,
      navigate: "/settings/recruitmentinstructions",
    },
    {
      name: "Terms of Services",
      isActive: false,
      navigate: "/settings/termsofservices",
    },
    {
      name: "Privacy & Policy",
      isActive: false,
      navigate: "/settings/privacyandpolicy",
    },
    {
      name: "FAQs",
      isActive: false,
      navigate: "/settings/faqs",
    },

  ];

  const FieldAgentSideBarData = [
    {
      name: "My Profile",
      isActive: false,
      navigate: "/settings/profile",
    },
    {
      name: "Change Pasword",
      isActive: false,
      navigate: "/settings/changepasword",
    },
    {
      name: "Terms of Services",
      isActive: false,
      navigate: "/settings/termsofservices",
    },
    {
      name: "Privacy & Policy",
      isActive: false,
      navigate: "/settings/privacyandpolicy",
    },
    {
      name: "FAQs",
      isActive: false,
      navigate: "/settings/faqs",
    },
    {
      name: "Delete Account",
      isActive: false,
      // navigate: "/settings/faqs",
    },
  ];

  const HandleSideBarData = () => {
    if (localStorage.getItem("@userType") == "superadmin") {
      setSideBarData(AdminSideBarData);
    } else {
      setSideBarData(FieldAgentSideBarData);
    }
  };

  useEffect(() => {
    HandleSideBarData();
  }, []);
  const NavigatePath = (row) => {
    if (row.name != "Delete Account") {
      navigate(row.navigate);
    } else {
      setConformModal(true)
    }
  };
  const DeletCandidateAccount = async () => {
    try {
      if (!Checked) {
        toast.warn("Please check the box to confirm");
        return;
      }
      setDeleteLoader(true);
      const userida = localStorage.getItem("@userid");
      if (!userida) {
        toast.warn("User authentication Failed ");
        return;
      }
      let url = "candidate/deleteaccount";
      let method = "PUT";
      let params = {
        candidate_uuid: userida,
      };
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        toast.success("Your Account Deleted Successfully");
        setConformModal(false);
        setSuccessModal(true);
        setDeleteLoader(false);
      } else {
        toast.error("Something went wrong please try again");
        setDeleteLoader(false);
      }
    } catch (Error) {
      setDeleteLoader(false);
      toast.error("Something went wrong please try again");
      console.log("Error", Error);
    }
  };
  const LogoutConfirmations = () => {
    LogoutUser();
  };
  return (
    <Grid
      container
      lg={12}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Box className="w-100 h-100">
        {SideBarData.map((row, i) => {
          return (
            <Grid
              item
              lg={11}
              className="mb-3 rounded pointer borderRadius4"
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              key={i}
              sx={{
                backgroundColor:
                  Locationfilter(location.pathname) == row.navigate
                    ? "#0FBE7C"
                    : "transparent",
                padding: "2.9%",
              }}
              onClick={() => NavigatePath(row)}
            >
              <p
                className="poppinsRegular text-left"
                style={{
                  color:
                    Locationfilter(location.pathname) == row.navigate
                      ? "#FFFFFF"
                      : "#222222",
                }}
              >
                {" "}
                {row.name}
              </p>
            </Grid>
          );
        })}
      </Box>
      <CustomModal
        open={ConformModal}
        setOpen={setConformModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "35%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleQuestion color={"#E62A4A"} size={100} />
            <p className="poppinsRegular Text-Prime-Black pt-3 text-center">
              Are you sure you want to delete your account? Deleting your
              profile will remove your application history and details from the
              platform, and this cannot be undone.
            </p>
            <Grid
              lg={12}
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
              }}
              alignItems={"center"}
            >
              <CustomCheckBox
                disableColor={"transparent"}
                checked={Checked}
                onChange={() => setChecked(!Checked)}
              />
              <p>I confirm that I want to delete my account permanently.</p>
            </Grid>
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"center"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setConformModal(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <RedColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => DeletCandidateAccount()}
            >
              {DeleteLoader ? (
                <CircularProgress size="1rem" style={{ color: "#fff" }} />
              ) : (
                "Yes"
              )}
            </RedColorButton>
          </Grid>
        }
      />
      <CustomModal
        open={SuccessModal}
        setOpen={setSuccessModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleQuestion color={"#E62A4A"} size={100} />
            <p className="poppinsRegular Text-Prime-Black pt-3 text-center">
              Your Account Deleted Successfully
            </p>
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"center"}>
            <RedColorBorderButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => LogoutConfirmations()}
            >
              ok
            </RedColorBorderButton>
          </Grid>
        }
      />
    </Grid>
  );
};

export default SideBarData;
